{
  "errorFallback": {
    "message": "Impossible d’afficher ce bloc."
  },
  "emptyState": {
    "clickPencilAbove": "<text>Cliquez sur</text><pencil/><text>ci-dessus</text><arrow/>",
    "doubleClickToEdit": "Double-cliquez pour modifier"
  },
  "iframeGate": {
    "clickToInteract": "Cliquez pour interagir"
  },
  "grip": {
    "title": "Glisser pour déplacer · Clic droit pour le menu"
  },
  "toolbar": {
    "openInWindow": "Ouvrir dans une fenêtre"
  },
  "noleBead": {
    "editedByNole": "Modifié par Nolë",
    "writing": "Écriture…",
    "reading": "Lecture…",
    "done": "Terminé"
  },
  "displayOptions": {
    "showTitle": "Afficher le titre",
    "scaleWithZoom": "Suivre le zoom",
    "collapsibleSections": "Sections repliables"
  },
  "extraction": {
    "filling": "Remplissage…",
    "failed": "Impossible de remplir les champs.",
    "couldNotFill": "Échec du remplissage",
    "dismissTitle": "{{message}}\nCliquez pour masquer.",
    "dismissFailed": "Impossible de masquer l’erreur"
  },
  "custom": {
    "unknownTemplate": "Modèle inconnu"
  },
  "edit": {
    "editFile": "Modifier le fichier",
    "editAppTitle": "Modifier le titre de l’app",
    "editLink": "Modifier le lien",
    "titleOptional": "Titre (facultatif)",
    "title": "Titre",
    "linkTitleFetchFailed": "Impossible de récupérer le titre de la page",
    "linkUrlPlaceholder": "URL ou code d’intégration <iframe>…",
    "renameOrReplace": "Renommer ou remplacer",
    "addFile": "Ajouter un fichier",
    "fileName": "Nom du fichier",
    "imageFallbackName": "image",
    "extractToNewNode": "Extraire dans un nouveau node",
    "splitAll_one": "Tout séparer ({{count}})",
    "splitAll_other": "Tout séparer ({{count}})",
    "addImages": "Ajouter des images",
    "manageImages": "Gérer les images",
    "library": "Bibliothèque",
    "manageVideo": "Modifier la vidéo",
    "file": "Fichier",
    "generate": "Générer"
  },
  "image": {
    "empty": "Aucune image",
    "defaultName": "Image",
    "generate": "Générer",
    "altIndexed": "Image {{index}}",
    "generationStartFailed": "Impossible de lancer la génération",
    "launchGeneration": "Lancer la génération d’image",
    "generating": "Génération…",
    "generatedWith": "Générée avec {{model}}"
  },
  "value": {
    "edit": "Modifier la valeur",
    "value": "Valeur",
    "yes": "Oui",
    "no": "Non",
    "number": "Nombre",
    "text": "Texte",
    "optionsOptional": "Options (facultatif)",
    "type": "Type",
    "yesNo": "Oui/Non",
    "unitOptional": "Unité (facultatif)",
    "unitPlaceholder": "kg, €, %…",
    "labelOptional": "Libellé (facultatif)",
    "label": "Libellé",
    "empty": "Aucune valeur"
  },
  "file": {
    "empty": "Aucun fichier"
  },
  "blocknote": {
    "fallbackTitle": "Document",
    "markdownConversionFailed": "Impossible de convertir ce document en Markdown",
    "downloadAsMarkdown": "Télécharger en Markdown"
  },
  "link": {
    "empty": "Aucun lien",
    "copied": "Lien copié dans le presse-papiers",
    "copyFailed": "Impossible de copier le lien",
    "copyLink": "Copier le lien",
    "copyLinkUrl": "Copier l’URL du lien",
    "refreshEmbed": "Actualiser l’intégration",
    "embeddedContent": "Contenu intégré"
  },
  "app": {
    "fallbackTitle": "App",
    "refresh": "Actualiser l’app",
    "refreshLabel": "Actualiser",
    "downloadCode": "Télécharger le code",
    "empty": "Aucune app",
    "emptyHint": "Demandez à Nolë de coder quelque chose"
  },
  "table": {
    "fallbackTitle": "Tableau",
    "visibleOfTotal": "{{shown}} sur {{total}}"
  },
  "database": {
    "fallbackTitle": "Base de données",
    "addTo": "Ajouter à {{title}}",
    "empty": "Aucune ligne pour l’instant",
    "emptyHint": "Double-cliquez sur le titre pour l’ouvrir",
    "previewCount_one": "{{shown}} sur {{total}} ligne",
    "previewCount_other": "{{shown}} sur {{total}} lignes",
    "row": "Ligne",
    "addRow": "Ajouter une ligne"
  },
  "databaseView": {
    "fallbackName": "Vue",
    "renameFailed": "Impossible de renommer la vue",
    "databaseMissing": "Sa base de données est dans la corbeille ou sur un autre canvas"
  },
  "transcribe": {
    "running": "Transcription…",
    "runningProgress": "Transcription… {{done}}/{{total}}",
    "runningTitle": "Transcription en cours — vous pouvez continuer à travailler",
    "transcript": "Transcription",
    "openTranscript": "Ouvrir la transcription",
    "transcribe": "Transcrire",
    "tooLarge": "Fichier trop volumineux pour être transcrit",
    "tooLargeWithMax": "Fichier trop volumineux pour être transcrit (max. {{max}} Mo)",
    "failed": "Échec de la transcription : {{error}}. Cliquez pour réessayer.",
    "unknownError": "erreur inconnue",
    "idleTitleAudio": "Transcrire cet audio pour rendre son contenu consultable par la recherche",
    "idleTitleVideo": "Transcrire cette vidéo pour rendre son contenu consultable par la recherche"
  },
  "media": {
    "playbackSpeed": "Vitesse de lecture",
    "mute": "Couper le son",
    "unmute": "Réactiver le son",
    "volume": "Volume",
    "play": "Lecture",
    "pause": "Pause",
    "backToStart": "Revenir au début",
    "clearLoop": "Effacer la boucle",
    "loopStartHere": "Commencer la boucle ici",
    "loopEndHere": "Terminer la boucle ici",
    "loopOff": "Désactiver la boucle",
    "loopOn": "Activer la boucle",
    "loopSetFirst": "Définissez d’abord un début et une fin",
    "noAudio": "Aucun audio",
    "noVideo": "Aucune vidéo",
    "formatUnsupported": "Ce navigateur ne peut pas lire ce format.",
    "downloadFile": "Télécharger le fichier"
  },
  "headingLevels": {
    "h1": "Titre 1",
    "h2": "Titre 2",
    "h3": "Titre 3",
    "p": "Texte"
  },
  "title": {
    "placeholder": "Cliquez pour modifier…",
    "style": "Style",
    "width": "Largeur",
    "autoFitWidth": "Largeur automatique",
    "autoFitWidthTitle": "Ajuster la largeur au texte",
    "titleSize": "Taille du titre"
  },
  "nodeCount": {
    "empty": "Vide",
    "nodes_one": "{{count}} node",
    "nodes_other": "{{count}} nodes"
  },
  "frame": {
    "untitled": "Frame sans titre"
  },
  "board": {
    "editLayout": "Modifier la mise en page",
    "untitled": "Board sans titre",
    "invalidLayout": "Mise en page du board invalide",
    "emptyText": "Texte vide",
    "rootLabel": "Board",
    "leafKinds": {
      "space": "Espace",
      "text": "Texte",
      "divider": "Séparateur"
    },
    "spaceFallbackName": "Espace {{rank}}",
    "spaceNameHint": "Le nom n’apparaît que dans cet éditeur.",
    "spaceNameHintWithNodes_one": "Le nom n’apparaît que dans cet éditeur. Supprimer cet espace déplace {{count}} node dans le premier espace.",
    "spaceNameHintWithNodes_other": "Le nom n’apparaît que dans cet éditeur. Supprimer cet espace déplace ses {{count}} nodes dans le premier espace."
  },
  "edge": {
    "bendHandleTitle": "Glisser pour remodeler · Clic droit pour supprimer",
    "removePoint": "Supprimer le point"
  },
  "generation": {
    "model": "Modèle",
    "settings": "Réglages de génération"
  },
  "imageGeneration": {
    "promptPlaceholder": "Décrivez l’image à générer…",
    "pricePerImage": "{{price}}/image",
    "generateCount_one": "Générer {{count}} image",
    "generateCount_other": "Générer {{count}} images",
    "clearTitle": "Effacer le prompt et recocher toutes les images branchées",
    "referenceLimitExceeded_one": "{{count}} image de référence pour un modèle qui en accepte {{max}}. Débranchez-en, excluez-les ou choisissez un autre modèle.",
    "referenceLimitExceeded_other": "{{count}} images de référence pour un modèle qui en accepte {{max}}. Débranchez-en, excluez-les ou choisissez un autre modèle.",
    "canCloseWindow": "Vous pouvez fermer cette fenêtre — les images arriveront sur le node.",
    "failed": "La génération a échoué.",
    "modelRequiresReferences": "Ce modèle retouche des images : branchez au moins un node image en entrée, ou choisissez un autre modèle.",
    "referencesHint": "Images branchées — cochez celles à envoyer",
    "count": "Nombre d’images",
    "countSummary_one": "{{count}} image",
    "countSummary_other": "{{count}} images",
    "incompatibleTooManyReferences": "{{max}} références max",
    "incompatibleNeedsSource": "Demande une image source",
    "capReferences": "{{count}} réf.",
    "capEditOnly": "retouche",
    "capCount": "1–{{max}} images"
  },
  "videoGeneration": {
    "referenceLimitExceeded_one": "{{count}} image de référence pour un modèle qui en accepte {{max}}. Débranchez-en, changez de mode ou de modèle.",
    "referenceLimitExceeded_other": "{{count}} images de référence pour un modèle qui en accepte {{max}}. Débranchez-en, changez de mode ou de modèle.",
    "noReferencesSupport": "Ce modèle n’accepte pas d’images de référence. Utilisez-les comme frames ou choisissez un autre modèle.",
    "promptPlaceholder": "Décrivez la vidéo : sujet, action, mouvement de caméra, son…",
    "pricePerSecond": "~{{price}}/s",
    "duration": "Durée",
    "durationValue": "{{count}} s",
    "resolution": "Résolution",
    "aspectRatio": "Format",
    "aspectAuto": "Auto",
    "audio": "Générer le son",
    "replaceWarning": "La vidéo générée remplacera la vidéo actuelle (elle reste dans l’historique des versions).",
    "generate": "Générer la vidéo",
    "clearTitle": "Effacer le prompt et réinitialiser l’usage des images connectées",
    "canCloseWindow": "Vous pouvez fermer cette fenêtre — la vidéo arrivera sur le node d’ici quelques minutes.",
    "failed": "La génération a échoué.",
    "startFrameName": "frame de début",
    "endFrameName": "frame de fin",
    "problemStartNotSupported": "Ce modèle n’a pas de frame de début : changez le rôle de l’image ou choisissez un autre modèle.",
    "problemEndNotSupported": "Ce modèle n’a pas de frame de fin (début seulement) : changez le rôle de l’image ou choisissez un autre modèle.",
    "problemDuplicateFrame": "Une seule image peut être le début, et une seule la fin.",
    "problemMixed": "Les frames Début/Fin et les références ne se combinent pas : OpenRouter ignorerait les références. Utilisez l’un ou l’autre.",
    "referenceName": "image {{index}}",
    "modeText": "Texte seul",
    "modeFrames": "Début → Fin",
    "modeReferences": "Références",
    "slotStart": "Début",
    "slotEnd": "Fin (optionnelle)",
    "slotEndUnavailable": "Fin — indisponible avec ce modèle",
    "unusedImages": "Non utilisées :",
    "changeImage": "Changer d’image",
    "pickImage": "Choisir une image",
    "clearSlot": "Retirer",
    "referencesHint": "Cochez les images qui guident la vidéo",
    "textHint": "Les images branchées ne sont pas envoyées : la vidéo vient du prompt seul.",
    "incompatibleNoEnd": "Pas de frame de fin",
    "incompatibleNoReferences": "Pas de références",
    "incompatibleTooManyReferences": "{{max}} références max",
    "capStartEnd": "début+fin",
    "capStartOnly": "début seul",
    "capReferences": "{{count}} réf.",
    "capAudio": "son",
    "capAudioAlways": "son inclus",
    "capDurations": "{{min}}–{{max}} s",
    "audioAlways": "Toujours inclus",
    "audioNone": "Pas de son",
    "fixRemoveEnd": "Retirer la frame de fin",
    "fixKeepFirst": "Garder les {{count}} premières",
    "fixUseModel": "Utiliser {{model}}",
    "modelHasNoReferences": "{{model}} ne prend pas d’images de référence.",
    "errorTimeout": "La vidéo a mis trop de temps à se générer et a été abandonnée. Réessayez, éventuellement avec une durée plus courte.",
    "errorRejected": "Le fournisseur a refusé cette demande (prompt, images ou réglages). Ajustez-les ou essayez un autre modèle.",
    "errorTooLarge": "La vidéo générée est trop lourde pour être stockée. Essayez une résolution plus basse ou une durée plus courte."
  },
  "promptMention": {
    "menuLabel": "Images connectées",
    "sentAs": "Envoyée au modèle comme « {{name}} »",
    "notSent": "Pas envoyée avec cette génération (références exclues ou non utilisées dans ce mode).",
    "notConnected": "Cette image n’est plus connectée : elle ne sera pas envoyée.",
    "imageName": "image {{index}}",
    "unsentBlocking": "Le prompt mentionne une image qui ne sera pas envoyée (en rouge). Rebranchez-la, changez les réglages ou retirez la mention.",
    "mentionInPrompt": "Mentionner dans le prompt"
  },
  "nodeTypes": {
    "title": {
      "label": "Titre",
      "description": "Node pour poser un texte libre sur le canvas. Niveaux de titre h1/h2/h3/p pour tout le texte, sans mise en forme riche."
    },
    "link": {
      "label": "Lien",
      "description": "Node pour enregistrer un lien."
    },
    "image": {
      "label": "Image",
      "description": "Node pour enregistrer une image."
    },
    "blocknote": {
      "label": "Document",
      "description": "Node pour un document en texte riche (éditeur BlockNote)."
    },
    "value": {
      "label": "Valeur",
      "description": "Node pour enregistrer une valeur (texte, nombre, booléen)."
    },
    "file": {
      "label": "Fichier",
      "description": "Node pour un fichier importé : PDF, Word, Excel, PowerPoint, texte, zip…"
    },
    "table": {
      "label": "Tableau",
      "description": "Node pour des données structurées en colonnes typées."
    },
    "database": {
      "label": "Base de données",
      "description": "Une collection de fiches typées par un modèle : chaque ligne a sa propre vie (historique, recherche, vue fiche)."
    },
    "databaseView": {
      "label": "Vue de base de données",
      "description": "Une vue d'une base de données sur le canvas : un tableau filtré, un kanban, une galerie ou une frise."
    },
    "app": {
      "label": "App",
      "description": "Node pour des apps React interactives : prototypes, maquettes, tableaux de bord, graphiques, calculateurs…"
    },
    "audio": {
      "label": "Audio",
      "description": "Node pour écouter un fichier audio importé, avec une boucle enregistrée."
    },
    "video": {
      "label": "Vidéo",
      "description": "Node pour lire un fichier vidéo importé."
    },
    "frame": {
      "label": "Frame",
      "description": "Conteneur qui regroupe des nodes. Les nodes d'une frame se déplacent avec elle et forment un ensemble."
    },
    "board": {
      "label": "Board",
      "description": "Conteneur découpé en espaces (colonnes, cases) qui rangent les nodes qu'on y dépose : un kanban, une matrice."
    },
    "custom": {
      "label": "Custom node",
      "description": "Un node construit à partir d'un de vos modèles."
    }
  },
  "variants": {
    "default": "Par défaut",
    "preview": "Aperçu",
    "embed": "Intégré",
    "carousel": "Carrousel",
    "grid": "Grille",
    "title": "Titre",
    "player": "Lecteur",
    "compact": "Compact",
    "expanded": "Déplié"
  },
  "video": {
    "generating": "Génération de la vidéo…",
    "generationStartFailed": "Impossible de lancer la génération vidéo",
    "uploadBlockedWhileGenerating": "L’import est désactivé pendant une génération : la vidéo générée le remplacerait.",
    "generatedWith": "Générée avec {{model}}"
  }
}
